import ScrollManager from './scrollManager';
import ShareUtil from './shareUtil';
import SearchView from './searchView';
import ArticleDetailView from './articleDetailView';
import PersonalityQuizView from './personalityQuizView';
import SideBarView from './sideBarView';
import LazyloadImage from './lazyloadImage';
import ToggleTextView from './toggleTextView';
import HeaderAds from './headerAds';
import ArticlePhotoView from './article/photoView';
import GameDetailView from './gameDetailView';
import GoogleAnalyticsManager from './googleAnalyticsManager';
import LoadMoreView from './loadMoreView';
import ABTestingView from './abTestingView';
import ContentSourceTracker from '../shared/contentSourceTracker';
import RecommendedMangaRensaiCarousel from '../shared/recommendedMangaRensaiCarousel';

const loadToggleTextViewInit = () => {
  const toggleTextView = new ToggleTextView();

  toggleTextView.init();
};

const loadMoreInit = () => {
  const loadMoreInstance = new LoadMoreView();

  loadMoreInstance.init();
};

const onReady = () => {
  ContentSourceTracker.init();
  RecommendedMangaRensaiCarousel.init();

  const shareUtilInstance = new ShareUtil();
  const searchInstance = new SearchView();
  const personalityQuizInstance = new PersonalityQuizView();
  const articleImageView = new ArticlePhotoView();
  const lazyloadImage = new LazyloadImage();
  const gameDetailView = new GameDetailView();
  const googleAnalyticsManager = new GoogleAnalyticsManager();
  const abTestingViewInstance = new ABTestingView();

  shareUtilInstance.init();
  searchInstance.init();
  personalityQuizInstance.init();
  articleImageView.init();
  lazyloadImage.init();
  gameDetailView.init();
  googleAnalyticsManager.init();
  abTestingViewInstance.init();

  const isArticlePage = document.querySelector('.js-article');

  if (isArticlePage) {
    const articleDetailInstance = new ArticleDetailView();

    articleDetailInstance.init();
  }

  const hasSideBar = document.querySelector('.js-side-bar-container');

  if (hasSideBar) {
    const scrollManagerInstance = new ScrollManager();
    const sideBarInstance = new SideBarView();

    scrollManagerInstance.init();
    sideBarInstance.init();
  }

  const isToggleTextPage = document.querySelector('.js-toggle-text-button');
  if (isToggleTextPage) loadToggleTextViewInit();

  const isLoadMorePage = document.querySelector('.js-load-more-container');
  if (isLoadMorePage) loadMoreInit();

  HeaderAds();
};

document.addEventListener('DOMContentLoaded', () => {
  onReady();
});
